import * as tslib_1 from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import { env } from '@ivy/fts/envInfo/envInfo';
import QuestionDetail from '../comps/question-detail.vue';
import showDiv, { closeAll } from '@ivy/fts/showDiv';
import testModal from '../comps/testModal.vue';
import * as shareApi from '../api/shareApi';
import * as util from '../../../util';
let ReimsAssess = class ReimsAssess extends Vue {
    constructor() {
        super(...arguments);
        this.audioStop = false;
        this.firstTestLength = 0;
        this.next = true;
        this.reimsList = [];
        this.currentIndex = 0;
        this.screenHeight = document.documentElement.clientHeight;
        this.originHeight = document.documentElement.clientHeight;
        this.resList = [];
        this.hasOperated = false;
        this.getText = '下一题';
    }
    get testValue() {
        let value = {
            single: this.dataInfo && this.dataInfo.single_submit,
            last: this.currentIndex === this.reimsList.length - 1,
        };
        return value;
    }
    getValue(val) {
        if (val.single && val.last) {
            this.getText = '提交';
        }
        if (['PM1', 'PM2'].includes(this.dataInfo.form_name) && val.last) {
            this.getText = '提交';
        }
    }
    async created() {
        await this.onReady();
    }
    // 监听微信自带返回按钮
    async onReady() {
        window.history.pushState({ url: '#' }, '监听用户返回操作', '#');
        window.onpopstate = () => this.pushHistory();
    }
    // 修改拦截的返回事件
    pushHistory() {
        window.history.pushState({ url: '#' }, '监听用户返回操作', '#');
        showDiv(testModal);
        if (window.modals.length > 1) {
            closeAll();
            window.modals.length = 0;
        }
    }
    async mounted() {
        await env.init();
        env.type === 'wx' && (await shareApi.share());
        await this.testData();
        await util.hideWxShareItems();
        let scrollList = this.$refs.scrollList;
        scrollList &&
            scrollList.style &&
            (scrollList.style.transform = `translateX(${-this.currentIndex * 100}vw)`);
        window.onresize = () => (() => {
            this.screenHeight = document.documentElement.clientHeight;
        })();
    }
    // 获取测评题
    async testData() {
        let { data } = await shareApi.requireGet('/api/m-course/lexile/createTest');
        this.dataInfo = data;
        this.firstTestLength = data.items.length;
        this.reimsList = data.items;
        this.testId = data.test_id;
    }
    // 选择答案
    chooseAnswer(data) {
        this.audioStop = false;
        if (data) {
            this.next = false;
        }
        let index = this.resList.findIndex(item => item.ims_id === data.id);
        if (index !== -1) {
            Vue.set(this.resList[index], 'answer', data.name);
        }
        else {
            this.resList.push({
                ims_id: data.id,
                answer: data.name,
            });
        }
    }
    // 下一题
    async goNext() {
        if (this.currentIndex < this.reimsList.length - 1) {
            this.audioStop = true;
            this.currentIndex++;
            this.next = true;
            if (this.dataInfo.single_submit) {
                this.submit(false);
            }
        }
        else {
            this.submit(true);
        }
    }
    // 提交测评结果
    async submit(val) {
        let { data } = await shareApi.requirePost('/api/m-course/lexile/submit', {
            test_id: this.dataInfo.test_id,
            form_name: this.dataInfo.form_name,
            is_last: val,
            answers: this.resList,
        });
        if (data.items) {
            this.reimsList = data.items;
            this.dataInfo = data;
            this.resList = [];
            this.currentIndex = 0;
            this.next = true;
            this.audioStop = false;
        }
        if (data.score) {
            if (this.dataInfo.form_name === 'PT') {
                // 完成蓝思定位测评埋点
                await shareApi.getUpload('Finish_PlacementTest_Lexile');
            }
            else {
                // 完成蓝思阶段测评埋点
                await shareApi.getUpload('Finish_ProgressMonitoringTest_Lexile');
            }
            this.$router.push(`/reimsAssess/result?test_id=${this.testId}&fromTest=1&_hideShareButton=1`);
        }
    }
};
tslib_1.__decorate([
    Watch('testValue')
], ReimsAssess.prototype, "getValue", null);
ReimsAssess = tslib_1.__decorate([
    Component({
        components: {
            QuestionDetail,
        },
    })
], ReimsAssess);
export default ReimsAssess;
